import { createContext, ReactNode, useContext, useReducer } from "react";

import { InitialContext } from "../types/state/context";
import {
  MyApprovalRequestTypes,
  MyApprovalsState,
} from "../states/meta-artwork/my-approval-request/data.type";
import { MyApprovalsReducer } from "../states/meta-artwork/my-approval-request";

type Context = InitialContext<MyApprovalsState, MyApprovalRequestTypes>;

export const MasterArtworkMyApprovalContext = createContext<Context>({} as Context);

export function MasterMyApprovalContextProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [state, dispatch] = useReducer(
    MyApprovalsReducer.reducer,
    MyApprovalsReducer.initialState,
  );

  return (
    <MasterArtworkMyApprovalContext.Provider value={{ state, dispatch }}>
      {children}
    </MasterArtworkMyApprovalContext.Provider>
  );
}

export const useMasterArtworkMyApprovalContextStore = () =>
  useContext(MasterArtworkMyApprovalContext);
